import type { LatLngExpression } from "leaflet";

/**
 * Decodes a polyline string (v6 format) into an array of [lat, lng] coordinates
 * Used for decoding route paths from the route_waypoints API
 */
export function decodePolyline(encoded: string): LatLngExpression[] {
  // Return empty array for empty or null input
  if (!encoded || encoded.length === 0) {
    return [];
  }

  const coordinates: [number, number][] = [];
  let index = 0;
  let lat = 0;
  let lng = 0;

  while (index < encoded.length) {
    let b: number;
    let shift = 0;
    let result = 0;

    // Decode latitude
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const dlat = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
    lat += dlat;

    shift = 0;
    result = 0;

    // Decode longitude
    do {
      b = encoded.charCodeAt(index++) - 63;
      result |= (b & 0x1f) << shift;
      shift += 5;
    } while (b >= 0x20);

    const dlng = (result & 1) !== 0 ? ~(result >> 1) : result >> 1;
    lng += dlng;

    // Convert to degrees and add to coordinates
    // v6 format uses 1e6 precision
    coordinates.push([lat / 1e6, lng / 1e6]);
  }

  return coordinates;
}
